/*@flow*/
import type { Element } from 'react';
import React from 'react';
import Present from 'lib/Present';

export default function ErrorsView({
  errors,
  error,
  className = 'alert alert-danger mb-3',
}: {
  errors?: ?(any[]),
  error?: ?{ message: string },
  className?: ?string,
}): null | Element<'div'> {
  if (!Present.is(errors) && !Present.is(error)) return null;
  let items = [];

  if (errors) {
    if (!Array.isArray(errors)) {
      items = [errors];
    } else {
      items = errors;
    }
  }

  if (error) {
    if (!Array.isArray(error)) {
      items = items.concat([error]);
    } else {
      items = items.concat(error);
    }
  }

  items = items.map((v) => {
    if (typeof v === 'string') return v;
    return v.message;
  });

  return (
    <div data-testid="ErrorsView" className={className}>
      {items.map((v, i) => (
        <div key={i}>{v}</div>
      ))}
    </div>
  );
}
